module.exports = __webpack_public_path__ + "img/sp_article_13.f3efd102.jpg";